import React from "react";
import Shared02Headings from "../../../../../guestsharedcomponents/Shared02Headings/Shared02Headings";

const SliderCard01 = ({ options }) => {
  //Des
  const {
    objinfo = {},
    index,
    videoRef,
    handleProcess,
    setVideo,
    handleLoadedMetaData,
  } = options;
  const { _id, card_heading = {}, card_content = {} } = objinfo || {};
  const { src_content } = card_content || {};

  return (
    <div key={_id} className="slider">
      <div className="video-carousel_container">
        <div className="bg-cover"></div>
        <Shared02Headings options={card_heading} />

        <div className="sub-container-video">
          <video
            playsInline={true}
            //className={`${_id === 2 && "translate-x-444"}`}
            preload="auto"
            muted
            ref={(el) => (videoRef.current[index] = el)}
            onEnded={() =>
              index !== 3
                ? handleProcess("video-end", index)
                : handleProcess("video-last")
            }
            onPlay={() => setVideo((pre) => ({ ...pre, isPlaying: true }))}
            onLoadedMetadata={(e) => handleLoadedMetaData(index, e)}
          >
            <source src={src_content} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default SliderCard01;
